import { UploadFile } from "antd";
import { RcFile } from "antd/es/upload";
import { ClipboardEvent } from "react";
import uuid from "react-uuid";
import ImageUploaderStore from "../../stores/common/image-uploader";

const handleKeybordPhotoPaste = (event: ClipboardEvent<HTMLDivElement>, photoUploaderStore: ImageUploaderStore, solutionUploaderStore: ImageUploaderStore) => {

    console.log("paste1");

    if (event.clipboardData.files.length) {
        console.log("paste2");
        const ff = event.clipboardData.files[0];
        const file: UploadFile = {
            name: ff.name,
            size: ff.size,
            type: ff.type,
            uid: uuid(),
            originFileObj: ff as RcFile
        };

        photoUploaderStore.handleManualUpload(file);
        solutionUploaderStore.handleManualUpload(file);
    }
};

export default handleKeybordPhotoPaste;